import './globals'
import './dependencias'
import './index.css'
import React from 'react';
import ReactDOM from 'react-dom/client';
import { LoaderProvider } from './hooks/useLoader';
import { ToastContainer } from 'react-toastify';
import { SistemaProvider } from './hooks/useSistema';
import { toastifyConfig } from './consts';
import { APIServiceProvider } from './hooks/useAPIService';
import { ModalProvider } from './hooks/useModal';
import { Router } from './main/Router';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <LoaderProvider>
    <ToastContainer {...toastifyConfig} />
    <APIServiceProvider>
      <SistemaProvider>
        <ModalProvider>
          <Router />
        </ModalProvider>
      </SistemaProvider>
    </APIServiceProvider>
  </LoaderProvider>,
  // </React.StrictMode>
)
